module.exports = __webpack_public_path__ + "static/media/play.8bf1a901.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PlayTrackLink/play.svg
// module id = 252
// module chunks = 0